module.exports = __webpack_public_path__ + "media/images/extra_link-10ff901a90f0ea5f71275d44b2399c63.svg";